import { Alert, Box, Button, Paper, Typography } from "@mui/material";
import { FormEvent, FunctionComponent, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Modal } from "../common/components/Modal";
import PasswordInput from "../common/components/PasswordInput";
import { RouteApp } from "../common/model/RouteApp";
import { useAppDispatch, useAppSelector } from "../common/redux/reduxHooks";
import { RootState } from "../common/redux/store";
import { postNewPassword } from "./redux/authAction";
import { useTranslation } from "react-i18next";

export const ResetPasswordPage: FunctionComponent = () => {
    const [searchParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const navigate = useNavigate();
    const authSelector: any = useAppSelector((state: RootState) => state.auth);

    const { t } = useTranslation();

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const token = searchParams.get("token");

        if (data.get("password") && token) {
            dispatch(postNewPassword(data.get("password") as string, token));
        }
    }

    useEffect(() => {
        if (authSelector.isSuccessPasswordConfirm) {
            setIsOpenModal(true);
            setErrorMessage(null);
        } else if (authSelector.isErrorPasswordConfirm) {
            setErrorMessage("Une erreur est survenue");
            setIsOpenModal(false);
        }
    }, [
        authSelector.isSuccessPasswordConfirm,
        authSelector.isErrorPasswordConfirm,
    ]);

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100dvh",
            }}
        >
            <Paper
                elevation={2}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: "fit-content",
                    textAlign: "center",
                    margin: "5px",
                }}
            >
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    noValidate
                    sx={{ mt: 1, padding: "20px" }}
                >
                    <Typography variant="h5" mb={1}>
                        {t("reset.password.title")}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={3}>
                        {t("reset.password.subtitle")}
                    </Typography>
                    <PasswordInput label={t("inputLabels.newPassword")} />
                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="error"
                        sx={{ mt: 3, mb: 3, padding: "10px" }}
                    >
                        {t("button.reset.password")}
                    </Button>

                    {errorMessage && (
                        <Alert severity="error" className="errorMessage">
                            {errorMessage}
                        </Alert>
                    )}
                </Box>

                <Modal
                    open={isOpenModal}
                    message={"Votre mot de passe a bien été modifié"}
                    title={"Confirmation de changement de mot de passe"}
                    onClose={() => {
                        setIsOpenModal(false);
                        setErrorMessage(null);
                    }}
                    onValidation={() => {
                        setIsOpenModal(false);
                        setErrorMessage(null);
                        navigate(RouteApp.LOGIN);
                    }}
                    titleButtonValidation={"Valider"}
                ></Modal>
            </Paper>
        </div>
    );
};
